import {
  ORG_STATUSES as SharedORG_STATUSES,
  ORG_NOTIFICATION_TYPES as SharedORG_NOTIFICATION_TYPES,
  VANITY_URL_STATUSES as SharedVANITY_URL_STATUSES,
} from "shared/dist/types/Org";

import type {
  Org as SharedOrg,
  MonthDay,
  SeasonMonthDays,
  OrgStatus,
  OrgNotificationType,
  TimeOfDay,
  VanityUrlStatus,
} from "shared/dist/types/Org";

export type {
  MonthDay,
  SeasonMonthDays,
  OrgStatus,
  OrgNotificationType,
  TimeOfDay,
  VanityUrlStatus,
};

export const ORG_STATUSES = SharedORG_STATUSES;
export const ORG_NOTIFICATION_TYPES = SharedORG_NOTIFICATION_TYPES;
export const VANITY_URL_STATUSES = SharedVANITY_URL_STATUSES;

export default interface Org extends SharedOrg {}